import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CREW_INFO, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { ExternalCrewInfo } from 'src/app/models/ExternalCrewInfo';

@Injectable({
  providedIn: 'root'
})
export class ExternalAuthenticationGuard {

  constructor(private router: Router) { }

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const crewInfo = getItemFromSessionStorage<ExternalCrewInfo>(CREW_INFO);

      // No crew info in session - redirect to login
      if (!crewInfo) {
        return this.router.createUrlTree(['/external-login']);
      }

      // Security check: Block access if user is blocked
      if (crewInfo.blocked) {
        return this.router.createUrlTree(['/external-login']);
      }

      // Security check: User must have access granted
      if (!crewInfo.hasAccess) {
        return this.router.createUrlTree(['/external-login']);
      }

      // Security check: Redirect to validation page if MFA or first access required
      // This prevents bypass by refreshing the page
      const targetUrl = state.url;
      const needsValidation = crewInfo.requiresMfa || crewInfo.firstAccess;

      if (needsValidation && targetUrl.includes('/external-home')) {
        return this.router.createUrlTree(['/external-validation']);
      }

      // Allow access
      return true;
  }

}
